<template>
    <div id='storeManagement' >
        <div class="left-store-nav">
             <el-row  style="margin:20px 0px 20px 20px; " v-if="permission.btn_warehouse_add">
                <el-button icon="el-icon-plus" type="primary" size="mini" @click="addWindowShow()">新增</el-button>
                <el-button type="primary" size="mini" @click="showPrintAll">批量打印条码</el-button>
            </el-row>
            <el-scrollbar  style="">
            <el-tree  ref="tree"  :default-expanded-keys="[selecTree]"
                :current-node-key='selecTree' node-key="id"
                class="tree-list" highlight-current accordion
                :data="data" :expand-on-click-node="true"
                :props="defaultProps" @node-click="handleNodeClick"
                :render-content="testContent">
            </el-tree>
            </el-scrollbar>
        </div>
        <div class="right-store-list">
            <div style="margin:0 24px;">
                <div class="table_searchbar">
                    <el-row >
                        <el-col :span="9">
                            <div class="">
                                <span class="title">物料编码： </span>
                                <el-select remote
                                    @visible-change="changeToOldData($event,1)"
                                    :remote-method="(query)=>{this.remoteMethod2(query,1)}" @change="materialChange" size="small" filterable style="max-width:180px" v-model="searchForm.materialId"   placeholder="物料编码"  >
                                    <el-option v-for="item in searchList" :key="item.id" :label="item.materialCode" :value="item.id">
                                    </el-option>
                                    <div v-if="searchList.length > 9"  class="search-keyword" style="text-align:center">
                                        <span style="font-size:12px;color:red">只显示前10条结果，请完善搜索关键字</span>
                                    </div>
                                </el-select>
                            </div>
                        </el-col>
                        <el-col :span="9">
                            <div class="">
                                <span class="title">物料名称： </span>
                                <el-select @change="materialChange" @visible-change="changeToOldData($event,1)" remote filterable
                                    :remote-method="(query)=>{this.remoteMethod2(query,2)}" size="small" style="max-width:180px" v-model="searchForm.materialId"   placeholder="物料名称" clearable >
                                    <el-option v-for="item in searchList" :key="item.id" :label="item.materialName?item.materialName:' '" :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="9">
                            <div class="">
                                <span class="title">规格： </span>
                                <el-select @change="materialChange" size="small" @visible-change="changeToOldData($event,1)" remote filterable
                                    :remote-method="(query)=>{this.remoteMethod2(query,3)}" style="max-width:180px" v-model="searchForm.materialId"   placeholder="规格"  clearable>
                                    <el-option v-for="item in searchList" :key="item.id" :label="item.specification?item.specification:'暂无规格'" :value="item.id">
                                        <span :style="item.specification?{}:{color:'red'}">{{item.specification?item.specification:'暂无规格'}}</span>
                                    </el-option>
                                </el-select>
                            </div>
                        </el-col>
                        <el-col :span="9">
                            <div class="">
                                <span class="title">批次： </span>
                                <el-select size="small" style="max-width:180px" v-model="searchForm.productionBatch"   placeholder="请先选择物料" filterable  clearable>
                                    <el-option v-for="item in batchOption" :key="item.id" :label="item.batchValue" :value="item.batchValue">
                                    </el-option>
                                </el-select>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div style="text-align:right">
                                <el-button icon="el-icon-search" size="mini" type="primary" @click="btnSearch()">查询</el-button>
                                <el-button icon="el-icon-refresh" size="mini"  @click='clearSearch'>重置</el-button>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div class="table_common_operbar">
                    <el-row>
                        <!-- <el-button v-if="permission.btn_stockIn_apply" icon="el-icon-my-enter" type="primary" size="small" @click="addStore()">入库申请</el-button> -->
                        <el-button size="mini" v-if="permission.btn_inventoryOfStock_submit" icon="el-icon-my-check" type="danger" @click="showCheckStore"  >盘点库存</el-button>
                        <el-button type="primary" size="mini" @click="printCode">打印条码</el-button>
                    </el-row>
                </div>
                <el-table :data="tableData"  style="width: 100%" class="deviceTable y_Public_table" >
                    <el-table-column prop="materialCode" label="物料编码"  min-width="80"></el-table-column>
                    <el-table-column prop="materialName" label="物料名称"  min-width="80">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.materialName" placement="top">
                                <div class="y_clamp">
                                    <div>{{scope.row.materialName}}</div>
                                </div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                     <el-table-column prop="materialSpecification" label="物料规格"  min-width="80"></el-table-column>
                    <el-table-column prop="itemAmount" label="数量"  min-width="80"></el-table-column>
                    <el-table-column prop="productionBatch" label="批次" min-width="80"></el-table-column>
                    <!-- <el-table-column label="操作" fixed="right" width="100">
                        <template slot-scope="scope">
                            <el-button type="text" @click="showEditdialog(scope.row)" size="small">编辑</el-button>
                            <el-button type="text" @click="deleteOrder(scope.row)" size="small">删除</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
                <div class="page" v-if="tableData.length > 0">
                    <div class="total_page"><span> 共{{tableTotalPage}}条 10条/页</span></div>
                    <div style="margin-top:10px;text-align:right; margin-bottom:20px;" >
                        <el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <!-- 新增入库 -->
        <!-- <el-dialog title="新增入库" @close="cancelAddMaterialDialog"  :visible.sync="addDialogVisible" :width="span==5?'26%':'33%'" center :close-on-click-modal="false">
            <el-form  ref="addMaterialForm" :rules="rules" :model="addMaterialForm" style="width:100%;" class="add_form">
                <el-row :gutter="20">
                    <el-col :offset="4" :span="18">
                        <div  class="">
                            <span class="title">物料编码：</span>
                            <el-form-item class="value" prop="materialId"  style="display:inline-block">
                                <el-select
                                    @visible-change="changeToOldData($event,2)"
                                    filterable
                                    remote
                                    :remote-method="remoteMethod"
                                    :loading="loading"
                                    @change="materialSelect($event)"
                                    size="small"  v-model="addMaterialForm.materialId" placeholder="物料编码"  style="display:block">
                                    <el-option v-for="item in materialList" :key="item.id" :label="item.materialCode" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :offset="4" :span="18">
                        <div  class="">
                            <span class="title">批次：</span>
                            <el-form-item prop="productionBatch"  style="display:inline-block">
                                <el-autocomplete class="value"  size="small" v-model="addMaterialForm.productionBatch" :fetch-suggestions="querySearch"
                                    placeholder="请选择或输入批次" @input="selectBatch($event)">
                                </el-autocomplete>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :offset="4" :span="18">
                        <div  class="">
                            <span class="title">入库类型：</span>
                            <el-form-item class="value" prop='type'  style="display:inline-block">
                                <el-select @change="typeChange" v-model="addMaterialForm.type" placeholder="入库类型" filterable style="display:block" size="small">
                                    <el-option v-for="item in addType" :key="item.id" :label="item.type" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :offset="4" :span="18">
                        <div  class="">
                            <span class="title">申请人：</span>
                            <el-form-item class="value" prop="applicantId"  style="display:inline-block">
                                <el-select v-model="addMaterialForm.applicantId" placeholder="申请人" filterable style="display:block" size="small">
                                    <el-option v-for="item in applicantList" :key="item.id" :label="item.label" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :offset="4" :span="18">
                        <div  class="">
                            <span class="title">入库单位：</span>
                            <el-form-item prop="itemAmount" class="value"  style="display:inline-block">
                                <el-select size="small"  v-model="addMaterialForm.unitType" placeholder="入库单位"  style="display:block">
                                    <el-option v-for="item in unitTypeOption" :key="item.id" :label="item.unitOfQuantity" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :offset="4" :span="18">
                        <div  class="">
                            <span class="title">数量：</span>
                            <el-form-item prop="itemAmount" class="value"  style="display:inline-block">
                                <el-input  v-model="addMaterialForm.itemAmount" placeholder="数量"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :offset="4" :span="18">
                        <div  class="">
                            <span class="title">备注：</span>
                            <el-form-item prop="configId" class="value" style="display:inline-block">
                                <el-input :autosize="{ minRows: 1,maxRows:3}" type="textarea" v-model="addMaterialForm.remark" placeholder="备注"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelAddMaterialDialog" >取 消</el-button>
                <el-button @click="submitMaterialAddForm" type="primary" >确 定</el-button>
            </span>
        </el-dialog> -->
        <!-- 新增入库 -->

        <!-- 新增仓库 -->
        <el-dialog title="新增仓库" @close="cancelAddDialog"  :visible.sync="addStoreDialogVisible" :width="span==5?'26%':'33%'" center :close-on-click-modal="false">
            <el-form :model="addForm" :rules="rules" ref="addForm" style="width:100%;" class="add_form">
                <el-row :gutter="20">
                    <el-col :offset="4" :span="18">
                        <div  class="">
                            <span class="title">新增类型：</span>
                            <el-form-item prop="type" class="value"  style="display:inline-block">
                                <el-select  size="small" @change="optionChange"  v-model="addForm.type" placeholder="新增类型"  style="display:block">
                                    <el-option v-for="item in storeOption" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                 <el-row :gutter="20" v-if="addForm.type ==2||addForm.type ==3">
                    <el-col :offset="4" :span="18">
                        <div  class="">
                            <span class="title">选择仓库：</span>
                            <el-form-item prop="storeId" class="value"  style="display:inline-block">
                                <el-select @change="selectStoreChange"  size="small"  v-model="addForm.storeId" placeholder="选择仓库" style="display:block">
                                    <el-option v-for="item in storeList" :key="item.id" :label="item.warehouseName" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                 <el-row :gutter="20" v-if="addForm.type ==3">
                    <el-col :offset="4" :span="18">
                        <div  class="">
                            <span class="title">选择库区：</span>
                            <el-form-item prop="storeAreaId" class="value"  style="display:inline-block">
                                <el-select  size="small"  v-model="addForm.storeAreaId" placeholder="选择库区" filterable style="display:block">
                                    <el-option v-for="item in storeArea" :key="item.id" :label="item.warehouseName" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" v-if="addForm.type ==3">
                    <el-col :offset="4" :span="18">
                        <div  class="">
                            <span class="title">输入库位：</span>
                            <el-form-item prop="storeLocation" class="value" style="display:inline-block">
                               <el-input v-model="addForm.storeLocation" placeholder="输入库位"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" v-if="addForm.type ==2">
                    <el-col :offset="4" :span="18">
                        <div  class="">
                            <span class="title">输入库区：</span>
                            <el-form-item prop="storeAreaName" class="value" style="display:inline-block">
                                <el-input v-model="addForm.storeAreaName" placeholder="输入库区"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" v-if="addForm.type ==1">
                    <el-col :offset="4" :span="18">
                        <div  class="">
                            <span class="title">输入库名：</span>
                            <el-form-item prop="warehouseName" class="value"  style="display:inline-block">
                                <el-input v-model="addForm.warehouseName" placeholder="输入库名"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" v-if="addForm.type ==1">
                    <el-col :offset="4" :span="18">
                        <div  class="">
                            <span class="title">仓库地址：</span>
                            <el-form-item prop="warehouseAddress" class="value"  style="display:inline-block">
                                <el-input v-model="addForm.warehouseAddress" placeholder="仓库地址"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" v-if="addForm.type ==1">
                    <el-col :offset="4" :span="18">
                        <div  class="">
                            <span class="title">仓库区域：</span>
                            <el-form-item  class="value"  style="display:inline-block">
                                <el-input v-model="addForm.position" placeholder="仓库区域"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitAddStore">确 定</el-button>
                <el-button @click="cancelAddDialog">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 新增仓库 -->

        <!-- 编辑仓库 -->
        <el-dialog :title="showTitle" @close="cancelEditDialog"  :visible.sync="editStoreDialogVisible" :width="span==5?'26%':'33%'" center :close-on-click-modal="false">
            <el-form :model="addForm" :rules="rules" ref="edit" style="width:100%;" class="add_form">
                <el-row :gutter="20"  v-if="addForm.type ==1">
                    <el-col :offset="4" :span="18">
                        <div  class="">
                            <span class="title">仓库名称：</span>
                            <el-form-item prop="warehouseName" class="value"  style="display:inline-block">
                                 <el-input v-model="addForm.warehouseName" placeholder="仓库地址"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>

                <el-row :gutter="20" v-if="addForm.type ==1">
                    <el-col :offset="4" :span="18">
                        <div  class="">
                            <span class="title">仓库地址：</span>
                            <el-form-item prop="warehouseAddress" class="value"  style="display:inline-block">
                                <el-input v-model="addForm.warehouseAddress" placeholder="仓库地址"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" v-if="addForm.type ==1">
                    <el-col :offset="4" :span="18">
                        <div  class="">
                            <span class="title">仓库区域：</span>
                            <el-form-item  class="value"  style="display:inline-block">
                                <el-input v-model="addForm.position" placeholder="仓库区域"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" v-if="addForm.type ==2">
                    <el-col :offset="4" :span="18">
                        <div  class="">
                            <span class="title">原始库区：</span>
                            <el-form-item  class="value"  style="display:inline-block">
                                <span>{{addForm.warehouseName}}</span>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" v-if="addForm.type ==2">
                    <el-col :offset="4" :span="18">
                        <div  class="">
                            <span class="title">修改库区：</span>
                            <el-form-item prop="storeAreaName" class="value"  style="display:inline-block">
                                <el-input v-model="addForm.storeAreaName" placeholder="输入修改库区"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>

                <el-row :gutter="20" v-if="addForm.type ==3">
                    <el-col :offset="4" :span="18">
                        <div  class="">
                            <span class="title">原始库位：</span>
                            <el-form-item   class="value"  style="display:inline-block">
                                <span>{{addForm.warehouseName}}</span>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" v-if="addForm.type ==3">
                    <el-col :offset="4" :span="18">
                        <div  class="">
                            <span class="title">修改库位：</span>
                            <el-form-item prop="storeLocation"  class="value"  style="display:inline-block">
                                <el-input v-model="addForm.storeLocation" placeholder="输入修改库位"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                 <el-row :gutter="20" v-if="addForm.type ==-1">
                    <el-col :offset="4" :span="18">
                        <div  class="">
                            <span class="title">原始名称：</span>
                            <el-form-item   class="value"  style="display:inline-block">
                                <span>{{addForm.warehouseName}}</span>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" v-if="addForm.type ==-1">
                    <el-col :offset="4" :span="18">
                        <div  class="">
                            <span class="title">修改名称：</span>
                            <el-form-item prop="companyName"  class="value"  style="display:inline-block">
                                <el-input v-model="addForm.companyName" placeholder="输入修改公司名称"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitEditStore">确 定</el-button>
                <el-button @click="cancelEditDialog">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 编辑仓库 -->

        <!-- 盘点仓库 -->
        <el-dialog title="盘点库存" @close="cancelCheck"  :visible.sync="checkDialog" :width="span==5?'60%':'80%'" center :close-on-click-modal="false">
           <el-form ref="checkForm" :rules="rules" :model="checkForm">
                <el-table :data="checkList" class="check-list"  style=" max-height:374px; height:auto;overflow-y: scroll;width: 100%;margin-bottom:10px;" >
                    <el-table-column label="序号" min-width="60">
                        <template slot-scope="scope">
                            <el-form-item>
                                <span>{{scope.$index+1}}</span>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="物料编码" min-width="110" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-form-item >
                               <span>{{scope.row.materialCode}}</span>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="批次" prop="content" min-width="110" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-form-item >
                                 <span>{{scope.row.productionBatch}}</span>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="所在仓库" prop="content" min-width="110" >
                        <template slot-scope="scope">
                            <el-form-item >
                                <el-tooltip :content="scope.row.warehouseName" placement="top">
                                 <span style="width:100px;display: inherit;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{scope.row.warehouseName}}</span>
                                </el-tooltip>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="库存数量" min-width="80" >
                        <template slot-scope="scope">
                            <el-form-item >
                               <span>{{scope.row.baseCount}}{{scope.row.baseUnit}}</span>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column  label="盘点单位" min-width="80">
                        <template slot-scope="scope">
                            <el-form-item class="y_store_width">
                                <el-select @change="checkUnitChange($event,scope.$index)" v-model="scope.row.unitId" placeholder="盘点单位"  style="display:block" size="small">
                                    <el-option v-for="item in checkUnitList[scope.$index]"  :key="item.id" :label="item.unitOfQuantity" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="比例" prop="content" min-width="60" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-form-item >
                                 <span>{{scope.row.conversionValue}}</span>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="盘点数量" min-width="110" >
                        <template slot-scope="scope">
                            <el-form-item :prop="`checkList[${scope.$index}].realAmount`" :rules="rules.checkCount">
                              <el-input @input="realCountChange($event,scope.$index)" v-model="scope.row.realAmount" style="display: inline-block;width: 70%;"></el-input>
                              <span>{{scope.row.unitOfQuantity}}</span>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="基本单位数量" min-width="100" >
                        <template slot-scope="scope">
                            <el-form-item >
                              <span>{{scope.row.checkBaseCount}}{{scope.row.baseUnit}}</span>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="差额"  min-width="80">
                        <template slot-scope="scope">
                           <el-form-item >
                               <span  v-if="!scope.row.checkBaseCount&&scope.row.gap!=null" :style="(scope.row.realAmount - scope.row.theoreticalAmount)<0&&scope.row.realAmount?{'color':'red'}:{'color':'green'}">{{scope.row.gap}}{{scope.row.baseUnit}}</span>
                               <span v-else :style="(scope.row.realAmount - scope.row.theoreticalAmount)<0&&scope.row.realAmount?{'color':'red'}:{'color':'green'}">{{scope.row.realAmount?(scope.row.checkBaseCount - scope.row.baseCount):''}}{{scope.row.baseUnit}}</span>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="备注"  min-width="140">
                        <template slot-scope="scope">
                            <el-form-item>
                                <el-input :autosize="{ minRows: 1,maxRows:3}" type="textarea" v-model="scope.row.remark" placeholder="备注"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                </el-table>
                <el-row>
                    <el-button type="primary" @click="addMaterial">添加物料</el-button>
                </el-row>
                <el-table class="check-list" :data="addList"  style="width: 100%;margin-bottom:10px;max-height:308px; height:auto;overflow-y: scroll;" >
                    <el-table-column label="序号" width="60">
                        <template slot-scope="scope">
                            <el-form-item >
                                <span>{{scope.$index+1}}</span>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column  label="物料编码" min-width="80">
                        <template slot-scope="scope">
                            <el-form-item class="y_store_width" :prop="`addList[${scope.$index}].materialId`" :rules="{required:true, message: '请选择物料编码', trigger: ['blur']}">
                                <el-select
                                @focus="focus($event,scope.$index)"
                                 filterable remote :remote-method="remoteMethod1" :loading="loading"
                                 @change="checkMaterialChange($event,scope)" v-model="addList[scope.$index].materialId" placeholder="物料编码"  style="display:block" size="small">
                                    <el-option v-for="item in checkMaterialList[scope.$index]" :key="item.id" :label="item.materialCode" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column  label="物料批次" min-width="80">
                        <template slot-scope="scope">
                            <el-form-item class="y_store_width"  :prop="`addList[${scope.$index}].productionBatch`"  :rules="{required:true, message: '请选择物料批次', trigger: ['blur','change']}">
                                <el-autocomplete  @focus='focus($event,scope.$index,scope.row)' style="display:block"
                                    :fetch-suggestions="querySearch1" size="small" v-model="addList[scope.$index].productionBatch"
                                    placeholder="请选择或输入批次" @input="batchSelect(scope)" >
                                </el-autocomplete>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column  label="仓库" min-width="80">
                        <template slot-scope="scope">
                            <el-form-item class="y_store_width" :prop="`addList[${scope.$index}].warehouseId`"  :rules="{required:true, message: '请选择仓库', trigger: 'blur'}">
                                <el-select v-model="scope.row.warehouseId" placeholder="仓库"  style="display:block" size="small">
                                    <el-option v-for="item in treeOption[scope.$index]" :disabled="item.disable" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column  label="盘点单位" min-width="80">
                        <template slot-scope="scope">
                            <el-form-item class="y_store_width">
                                <el-select @change="checkUnitChange($event,scope.$index,'add')" v-model="scope.row.unitId" placeholder="盘点单位"  style="display:block" size="small">
                                    <el-option v-for="item in addUnitList[scope.$index]"  :key="item.id" :label="item.unitOfQuantity" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="比例" prop="content" min-width="60" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-form-item >
                                 <span>{{scope.row.conversionValue}}</span>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column  label="盘点数量" min-width="80">
                        <template slot-scope="scope">
                            <el-form-item  :prop="`addList[${scope.$index}].realAmount`"  :rules="rules.checkCount1">
                                <el-input  style="display: inline-block;width: 70%;"  size="small" maxlength="16" v-model="scope.row.realAmount"></el-input>
                                <span>{{scope.row.unitOfQuantity}}</span>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column  label="备注" min-width="80">
                        <template slot-scope="scope">
                            <el-form-item class="y_store_width" :rules="{required:true, message: '备注', trigger: 'blur'}">
                                <el-input  size="small" maxlength="16" v-model="scope.row.remark"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column  label="操作" width="60">
                        <template slot-scope="scope">
                            <el-form-item>
                                <div class="delete"   type="primary"  @click="deleteMaterial(scope.$index)"></div>
                            </el-form-item>
                        </template>
                    </el-table-column>
                </el-table>
           </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="sumbitCkeck(1)">提 交</el-button>
                <el-button type="primary" @click="sumbitCkeck(0)">保 存</el-button>
                 <el-button @click="cancelRecord" type="danger">取消盘点</el-button>
            </span>
        </el-dialog>
        <!-- 盘点库存 -->

        <!-- 批量打印 -->
        <el-dialog title="批量打印条码" @close="cancelPrint"  :visible.sync="printDialog" :width="span==5?'40%':'50%'" center :close-on-click-modal="false">
            <el-tree :data="data" ref="printTree" :indent='30' show-checkbox default-expand-all node-key="id"  highlight-current :props="defaultProps"></el-tree>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="gotoPrint">确 定</el-button>
                <el-button  @click="cancelPrint">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 批量打印 -->

        <!-- 单个打印 -->
        <el-dialog title="二维码" :visible.sync="qrCodeDialogVisible" width="30%" center>
            <div id="qrcode" class="qrcode_div" ref="qrcodediv">
                <QrcodeVue :value="qrCode" size="200" level="H"></QrcodeVue>
            </div>
            <div class="qrcode_div" style="margin-top:20px;">
               
                <div style="margin-top:5px;margin-bottom:5px;"><span>{{printText}}</span></div>
                <el-button type="primary" @click="printQRCode()" size="medium">打印</el-button>
            </div>
        </el-dialog>
        <!-- 单个打印 -->
        
    </div>
</template>

<script>
let submitType =1
import QrcodeVue from 'qrcode.vue';
export default {
    name: 'StoreManagement',
    components: {
        QrcodeVue,
    },
	data () {
        let vm = this
        return {
            YmouserShow:null,
            printText:'',
            qrCode:'',
            qrCodeDialogVisible:false,
            printDialog:false,
            fristLoad:false,
            addUnitList:[],
            checkUnitList:[],
            oldData:[],
            clickNode:null,
            topWarehouseId:null,
            nodeClick : 1,
            checkForm:{
                checkList:[],
                addList:[],
            },
            unitTypeOption:[],
            selecTree:1,
            showTitle:'编辑仓库',
            selectTreeData:{},
            addList:[],
            treeOption1:[],
            treeOption:[],
            addType:[{id:1,type:'生产入库'},
            {id:2,type:'盘点入库'},

            {id:3,type:'采购入库'},],
            applicantList:[],
            addMaterialForm:{
                remark:null,
                id:null,
                warehouseId:null,
                productionBatch:null,
                materialId:null,
                itemAmount:null,
                applicantId: null,
                availableAmount:null,
                type:null,
                unitType:null
            },
            loading:false,
            materialList:[],
            storeList:[],
            searchList:[],
            editStoreDialogVisible:false,
            eidtDialogVisible:false,
            checkList:[
            ],
            editData:{},
            checkDialog:false,
            batchOption:[
            ],
            configOption:[],
            addStoreDialogVisible:false,
            W:false,
            materialCodeOption:[],
            addDialogVisible:false,
            addForm:{
                type:null,
                storeId:null,
                storeAreaId:null,
                position:null,
                warehouseAddress:null,
                warehouseName:null,
                storeLocation:null,
                storeAreaName:null,
                title:null,
                title1:null,
                companyName:null
            },
            storeArea:[],
            data: [],
            defaultProps: {
                children: 'next',
                label: 'warehouseName'
            },
            btnPressType: 0,//按钮类型： 0-默认 1-查询 2-重置 3-分页
            searchFormTemp: '',//临时搜索数据
            searchForm:{
                materialCode:null,
                specification:null,
                materialName:null
            },
            rules:{
                type:[
                    { required: true, message: '请选择添加类型', trigger: 'blur' }
                ],
                storeId:[
                    { required: true, message: '请选择仓库', trigger: 'blur' }
                ],
                storeAreaId:[
                    { required: true, message: '请选择库位', trigger: 'blur' }
                ],
               warehouseAddress:[
                    { required: true, message: '请输入仓库地址', trigger: 'blur' }
                ],
                warehouseName:[
                    { required: true, message: '请输入仓库名称', trigger: 'blur' }
                ],
                storeAreaName:[
                    { required: true, message: '请输入库区名称', trigger: 'blur' }
                ],
                storeLocation:[
                    { required: true, message: '请输入库位名称', trigger: 'blur' }
                ],
                companyName:[
                    { required: true, message: '请输入公司名称', trigger: 'blur' }
                ],
                materialId:[
                    { required: true, message: '请选择物料编码', trigger: 'blur' }
                ],
                applicantId:[
                    { required: true, message: '请选择负责人', trigger: 'blur' }
                ],
                productionBatch:[
                    { required: true, message: '请输入批次', trigger: ['blur','change'] }
                ],
                itemAmount:[
                    { required: true, message: '请输入入库数量', trigger: 'blur' },
                    {validator(rule, value, callback) {
                            if (Number.isInteger(Number(value)) && Number(value) > 0) {
                                callback()
                            } else {
                                callback(new Error('请输入正整数'))
                            }
                        },trigger: 'blur'
                    }
                ],
                checkCount:[
                    // { required: submitType==1?true:false, message: '请输入盘点数量', trigger: 'blur' },
                    {validator(rule, value, callback) {
                            log('666',submitType)
                            if(!value){
                                if(submitType==1){
                                    callback(new Error('请输入盘点数量'))
                                }else if(submitType==0){
                                    callback()
                                }
                            }
                            if (Number.isInteger(Number(value)) && Number(value) >= 0) {
                                callback()
                            } else {
                                callback(new Error('请输入非负整数'))
                            }
                        },trigger: 'blur'
                    }
                ],
                checkCount1:[
                    { required: true, message: '请输入盘点数量', trigger: 'blur' },
                    {validator(rule, value, callback) {
                            if (Number.isInteger(Number(value)) && Number(value) > 0) {
                                callback()
                            } else {
                                callback(new Error('请输入正整数'))
                            }
                        },trigger: 'blur'
                    }
                ],
                type:[
                    { required: true, message: '请选择入库类型', trigger: 'blur' }
                ],
            },
            tableData:[

            ],
            tableCurrentPage:1,
            tableTotalPage:5,
            storeOption:[
                {id:1,name:'仓库'},
                {id:2,name:'库区'},
                {id:3,name:'库位'}
            ],
            type:1,
            checkId:null,
            index:null,
            checkMaterialList:[],
            checkBatchList:[],
            permission:JSON.parse(localStorage.getItem("permission"))
        }
    },
    mounted:function(){
        this.loadStoreList()
        this.loadSearchList()
        this.loadApplicantList()
        this.loadMaterialList()
        let w  = document.documentElement.clientWidth || document.body.clientWidth;
        w>=1900?this.W = true:this.W = false
        window.onresize=()=>{
            let w  = document.documentElement.clientWidth || document.body.clientWidth;
            w>=1900?this.W = true:this.W = false
        }
        this.initTable()
    },
    computed:{
        span(){
           return this.W?5:7
        }
    },
    methods:{

        MmouseOver(ev) {
            console.log(ev)
            let offsetHeight = this.$refs.Mmover.offsetHeight
            let scrollHeight = this.$refs.Mmover.scrollHeight
            if(offsetHeight<scrollHeight){
                this.YmouserShow = ev
            }
            console.log(offsetHeight)
            console.log(scrollHeight)
        },
        Monmouseout() {
            this.YmouserShow = null
        },
        printQRCode(){
            var ss = this.$refs.qrcodediv;
            var imageToPrint = document.getElementById("qrcode").childNodes[0].childNodes[0]; //将要被打印的图片
            var printWindow = window.open(""); //新打开一个空窗口
            printWindow.document.write("<img src='"+imageToPrint.toDataURL()+"'/>"); //将图片添加进新的窗口
            printWindow.document.write("<div style='margin-top:5px;margin-bottom:5px;'><span>"+this.printText+"</span></div>"); 
            printWindow.document.close(); //在IE浏览器中使用必须添加这一句
            printWindow.focus(); //在IE浏览器中使用必须添加这一句
            setTimeout(function() {
                printWindow.document.body.style.textAlign = 'center'
                printWindow.print(); //打印
                printWindow.close(); //关闭窗口
            }, 100);
        },
        printCode(){
            if(this.selectTreeData.id){
               this.qrCode = `${this.$Global.baseUrl}/api/qrcode/getInfo?type=warehouse&id=${this.selectTreeData.id}`
                if(this.selectTreeData.layer==0||this.selectTreeData.layer==undefined){
                    this.printText = `仓库名称：${this.selectTreeData.warehouseName}`
                }else if(this.selectTreeData.layer==1){
                    this.printText = `库区名称：${this.selectTreeData.warehouseName}`
                }else{
                    this.printText = `库位名称：${this.selectTreeData.warehouseName}`
                }
                this.qrCodeDialogVisible = true
            }else{
                this.$message.warning('请选择要打印的仓库、库区或者库位')
            }
        },
        showPrintAll(){
            this.printDialog = true
        },
        gotoPrint(){
            if(this.$refs.printTree.getCheckedNodes().length>0){
                this.printDialog = false
                localStorage.setItem('printType','warehouse')
                let data = JSON.stringify(this.$refs.printTree.getCheckedNodes())
                localStorage.setItem('printData',data)
                let routeUrl = this.$router.resolve({path: "/printAll",});
                window.open(routeUrl .href, '_blank');
            }else{
                this.$message.warning('请选择打印数据')
            }
        },
        cancelPrint(){
            this.printDialog = false
        },
        realCountChange(ev,index){
            log(ev,this.checkList[index].realAmount,this.checkList[index].conversionValue)
            if(this.checkList[index].realAmount){
                this.$set(this.checkList[index],'checkBaseCount',this.checkList[index].realAmount*this.checkList[index].conversionValue)
            }else{
                this.$set(this.checkList[index],'checkBaseCount',null)
            }
        },
        checkUnitChange(ev,index,type){
            if(type=='add'){
                this.addUnitList[index].forEach(item=>{
                    if(item.id ==ev){
                        this.$set(this.addList[index],'unitOfQuantity',item.unitOfQuantity)
                        // let theoreticalAmount = this.checkList[index].theoreticalAmount/item.conversionValue
                        // this.$set(this.addList[index],'theoreticalAmount',theoreticalAmount)
                        this.$set(this.addList[index],'conversionValue',item.conversionValue)
                    }
                })
            }else{
                this.checkUnitList[index].forEach(item=>{
                    if(item.id ==ev){
                        this.$set(this.checkList[index],'unitOfQuantity',item.unitOfQuantity)
                        let theoreticalAmount = this.checkList[index].baseCount/item.conversionValue
                        this.$set(this.checkList[index],'theoreticalAmount',theoreticalAmount)
                        this.$set(this.checkList[index],'conversionValue',item.conversionValue)
                        if(this.checkList[index].realAmount){
                            this.$set(this.checkList[index],'checkBaseCount',this.checkList[index].realAmount*item.conversionValue)
                        }
                    }
                })
            }
        },
        typeChange(ev){
            if(ev==2){
                ev=3
            }else if(ev==3){
                ev=2
            }
            this.unitTypeOption.forEach(item=>{
                if(item.unitType==ev){
                    // this.addMaterialForm.unitType = item.id
                    this.$set(this.addMaterialForm,'unitType',item.id)
                }
            })
        },
        changeToOldData(ev,number){
            if(!ev){
                if(number==1){
                    this.searchList = this.oldData
                }else{
                    this.materialList = this.oldData
                }
            }
        },
        materialSelect(ev){
           if(ev){
               this.addMaterialForm.productionBatch = null
            //    this.addMaterialForm.unitType = null
               this.$set(this.addMaterialForm,'unitType',null)
               this.addMaterialForm.productionBatchId = null
               this.materialList.forEach(item=>{
                    if(item.id == ev){
                        this.batchOption = item.batchList
                        this.unitTypeOption = item.unitTypeList
                        item.unitTypeList.forEach(unit=>{
                            if(unit.unitType==3){
                                // this.addMaterialForm.unitType = unit.id
                                this.$set(this.addMaterialForm,'unitType',unit.id)
                            }
                        })
                   }
               })
           }
        },
        selectBatch(ev){
            this.addMaterialForm.productionBatchId = null
            if(this.batchOption.length>0){
                this.batchOption.forEach(item=>{
                    if(this.addMaterialForm.productionBatch==item.batchValue){
                        this.addMaterialForm.productionBatchId = item.id
                    }
                })
            }
            log('123',ev,this.addMaterialForm.productionBatchId)
        },
        querySearch(queryString, cb){
            var restaurants = this.batchOption;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            log('122',results)
            results.forEach(item=>{
                item.value = item.batchValue
            })
            cb(results);
        },
        querySearch1(queryString, cb,){
            if(this.checkBatchList[this.index]){
                var restaurants = this.checkBatchList[this.index];
            }else{
                var restaurants = []
            }
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            results.forEach(item=>{
                item.value = item.batchValue
            })
            cb(results);
        },
        createFilter(queryString){
            return (restaurant) => {
                if(restaurant.batchValue){
                    return (restaurant.batchValue.toLowerCase().indexOf(queryString.toLowerCase()) != -1);
                }
            };
        },
        batchSelect(scope){
            log('批次',this.addList[scope.$index].productionBatch)
            //检测当前批次值是否在当前批次列表中如此存在找到对应批次id如果不存在批次id设为null
            if(!this.addList[scope.$index].productionBatch){
                return
            }
            this.checkBatchList[scope.$index].forEach(b=>{
                if(b.batchValue==this.addList[scope.$index].productionBatch){
                    this.addList[scope.$index].productionBatchId = b.id
                }
            })
            let data = scope.row
            if(data.productionBatchId&&data.materialId){
                let list = []
                 this.treeOption[scope.$index].forEach(item=>{
                    item.disable=false
                })
                this.checkList.forEach(item=>{
                    if(data.productionBatch==item.productionBatch){
                        list.push(item.warehouseId)
                    }
                })
                this.treeOption[scope.$index].forEach((item,index)=>{
                    list.forEach(i=>{
                        if(item.id==i){
                           if(data.warehouseId == i){
                               data.warehouseId = null
                           }
                            item.disable=true
                        }
                    })
                })
            }
        },
        cancelRecord(){
            this.$confirm('是否确定取消盘点?', '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then( ()=>{
                this.$RequestUtil.post({
                    url: '/api/recordOfStockCounting/cancelRecordCounting',
                    params: {
                        recordOfStockCountingId: this.checkId,
                    },
                    success:(res)=>{
                        if(res.code==0){
                            this.$message.success('取消成功')
                            this.loadStoreList()
                            this.cancelCheck()
                        }else{
                            this.$message.error(res.message||res.msg)
                        }
                    }
                })
            })
        },
        cancelCheck(){
            this.checkDialog = false
            this.checkList = []
            this.addList=[]
            this.loadStoreList()
        },
        sumbitCkeck(type){
            submitType=type
            this.$refs['checkForm'].validate((valid) => {
                if(valid){
                    let arr = []
                    this.checkList.forEach(item=>{
                        log(888,item.realAmount,typeof item.realAmount)
                        if(item.realAmount==null||item.realAmount==''){
                            arr.push({id:item.id,realAmount:null,remark:item.remark})
                        }else{
                            arr.push({id:item.id,realAmount:item.realAmount*item.conversionValue,remark:item.remark})
                        }
                    })
                    this.addList.forEach(item=>{
                        let json= {
                            materialId: item.materialId,
                            productionBatchId:item.productionBatchId,
                            realAmount:item.realAmount*item.conversionValue,
                            remark:item.remark,
                            warehouseId:item.warehouseId,
                            productionBatch:item.productionBatch,
                        }
                        arr.push(json)
                    })
                    this.$RequestUtil.post({
                        url: '/api/inventoryOfStockCounting/submitCount',
                        params: {
                            recordOfStockCountingId: this.checkId,
                            flag: type,
                            dataList: arr
                        },
                        type:'sync',
                        success: (res) => {
                            if(res.code==0){
                                if(type==0){
                                    this.$message.success('保存成功')
                                }else{
                                    this.$message.success('提交成功')
                                }
                                this.loadStoreList()
                                this.cancelCheck()
                            }else{
                                this.$message.error(res.message||res.msg)
                            }
                        }
                    });
                }
            })
        },
        //通过物料id查找物料批次和物料单位
        async loadMaterialInfoById(materialId){
            let res = await this.$RequestUtil.getAsync({url: '/api/select/getDetailInfoOfMaterialViaId',params: {materialId},})
            return res.data
        },
        async loadRecordOfMaterial(){
            let res = await this.$RequestUtil.postAsync({
				url: '/api/recordOfStockCounting/count',
                params: {
                    warehouseId:this.addMaterialForm.warehouseId
                },
                type:'sync',
            });
            if(res.code==0){
                this.checkId = res.data.id
                for(let i=0;i<res.data.dataList.length;i++){
                    let item = res.data.dataList[i]
                    let materialInfo = await this.loadMaterialInfoById(item.materialId)
                    this.checkUnitList[i] = materialInfo.unitTypeList
                    item.baseCount = item.theoreticalAmount
                    item.unitId = this.checkUnitList[i][0].id
                    item.unitOfQuantity = this.checkUnitList[i][0].unitOfQuantity
                    item.conversionValue = this.checkUnitList[i][0].conversionValue
                    item.baseUnit = item.unitOfQuantity
                }
                this.checkList=res.data.dataList
                this.checkForm.checkList = this.checkList
            }else{
                this.$message.error(res.msg||res.message)
            }
			return res
        },
        deleteMaterial(index){
            this.addList.splice(index,1)
        },
        async addMaterial(){
            let index = this.addList.length
            let data = await this.loadMaterialList('')
            this.checkMaterialList[index] = data
            this.treeOption[index] = commonUtils.cloneObj(this.treeOption1)
            this.addList.push({materialCode:null,productionBatch:null,remark:null,realAmount:null,warehouseId:null})
            this.checkForm.addList = this.addList
        },
        cancelAddMaterialDialog(){
            this.addDialogVisible =false
            this.addMaterialForm={
                remark:null,
                id:null,
                productionBatch:null,
                itemAmount:null,
                applicantId: null,
                availableAmount:null,
                type:null,
                warehouseId:this.addMaterialForm.warehouseId
            }
        },

        loadApplicantList(){
            this.$RequestUtil.post({
				url: '/api/select/listWorker',
                params: {},
                type:'sync',
				success: (res) => {
					if(res.code == 0){
                        this.applicantList = res.data;
					}
				}
			});
        },
        submitMaterialAddForm(){
            this.$refs['addMaterialForm'].validate((valid) => {
                if(valid){
                     this.$RequestUtil.post({
                        url: '/api/stock/application/stockIn',
                        type:'sync',
                        params: {
                            data:{
                                topWarehouseId:null,
                                applicantId:this.addMaterialForm.applicantId,
                                stockInDetailList:[
                                    {
                                    warehouseId:this.addMaterialForm.warehouseId,
                                    applicantId:this.addMaterialForm.applicantId,
                                    amount:this.addMaterialForm.itemAmount,
                                    stockInType:this.addMaterialForm.type,
                                    remark:this.addMaterialForm.remark,
                                    timeOfStockIn:null,
                                    materialId:this.addMaterialForm.materialId,
                                    productionBatch:this.addMaterialForm.productionBatch,
                                    productionBatchId:this.addMaterialForm.productionBatchId,
                                    unitTypeId:this.addMaterialForm.unitType
                                    }
                                ]
                            }

                        },
                        success: (res) => {
                            if(res.code==0){
                                this.$message.success('新增入库成功')
                                this.cancelAddMaterialDialog()
                                this.initTable()
                            }else{
                                this.$message.error(res.message)
                            }
                        }
                    })
                }
             })
        },
        async remoteMethod(query) {
            this.loading = true;
            let data = await this.loadMaterialList(query)
            this.loading = false
            this.materialList = data
        },
        async remoteMethod2(query,type) {
            this.loading = true;
            let code='',materialName='',specification='';
            if(type==1){
                code = query
            }else if(type==2){
                materialName  = query
            }else{
                specification = query
            }
            log(1111111,query,type)
            let data = await this.loadMaterialList(code,materialName,specification)
            this.loading = false
            this.searchList = data
        },
        focus(ev,index){
            this.index = index
        },
        async remoteMethod1(query) {
            this.loading = true;
            let data = await this.loadMaterialList(query)
            this.loading = false
            log('12445',data,this.index)
            this.checkMaterialList[this.index] = data
        },
        async loadMaterialList(code='',materialName='',specification=''){
            if(code==null||code==undefined){
                code = ''
            }
            let res = await this.$RequestUtil.getAsync({url: '/api/select/listMaterialName',params: {code,materialName,specification}})
            if(!code){
                this.oldData=res.data
                this.materialList = res.data
            }
            return res.data
        },
        optionChange(){
                this.addForm.storeId=null
                this.addForm.storeAreaId=null
                this.addForm.position=null
                this.addForm.warehouseAddress=null
                this.addForm.warehouseName=null
                this.addForm.storeLocation=null
                this.addForm.storeAreaName=null
        },
        materialChange(ev){
            // this.searchForm.productionBatch = null
            this.$set(this.searchForm,'productionBatch',null)
            this.searchList.forEach(item=>{
                if(item.id == ev){
                     log(item)
                    this.batchOption = item.batchList
                }
            })
        },
        checkMaterialChange(ev,scope){
            this.checkMaterialList[scope.$index].forEach(item=>{
                if(item.id == ev){
                    this.$set(this.addList[scope.$index],'productionBatch',null)
                    this.checkBatchList[scope.$index] = item.batchList
                    this.addUnitList[scope.$index] = item.unitTypeList
                    this.$set(this.addList[scope.$index],'unitId',item.unitTypeList[0].id)
                    this.$set(this.addList[scope.$index],'unitOfQuantity',item.unitTypeList[0].unitOfQuantity)
                    this.$set(this.addList[scope.$index],'conversionValue',item.unitTypeList[0].conversionValue)
                    this.treeOption[scope.$index].forEach(t=>{
                        t.disable = false
                    })
                }
            })
        },

        loadSearchList(){
                this.$RequestUtil.get({
                url: '/api/select/listMaterialName',
                type:'sync',
				params: {
                    code:''
                },
                success: (res) => {
                   if(res.code==0){
                       this.searchList = res.data
                   }
                }
            })
        },
        submitAddStore(){
             this.$refs['addForm'].validate((valid) => {
                if(valid){
                    let params = {}
                    if(this.addForm.type ==1){
                        params.layer = 0
                        if(this.data[0]){
                            params.parentId=this.data[0].id
                        }

                        params.warehouseAddress = this.addForm.warehouseAddress
                        params.position = this.addForm.position
                        params.warehouseName = this.addForm.warehouseName
                    }else if(this.addForm.type ==2){
                        params.layer = 1
                        params.parentId=this.addForm.storeId
                        params.warehouseName = this.addForm.storeAreaName
                    }else if(this.addForm.type ==3){
                        params.layer = 2
                        params.parentId=this.addForm.storeAreaId
                        params.warehouseName = this.addForm.storeLocation
                    }
                    this.$RequestUtil.post({
                        url: '/api/warehouseController/addWarehouse',
                        type:'sync',
                        params,
                        success: (res) => {
                            if(res.code ==0){
                                this.$message.success('添加成功')
                                this.addStoreDialogVisible = false
                                this.addForm={
                                    type:null,
                                    storeId:null,
                                    storeAreaId:null,
                                    position:null,
                                    warehouseAddress:null,
                                    warehouseName:null,
                                    storeLocation:null,
                                    storeAreaName:null
                                }
                                this.loadStoreList(res.data.id)
                                this.addMaterialForm.warehouseId = res.data.id
                                this.searchForm.warehouseId = res.data.id
                                this.selectTreeData=res.data
                                this.btnPressType = 1
                                this.search()

                            }else{
                                this.$message.error(res.msg||res.message);
                            }
                        }
                    })
                }
             })
        },
        selectStoreChange(ev){
            log(this.storeList)
            log(this.addForm.storeId)
            if(!this.addForm.storeId){
                return
            }
            this.addForm.storeAreaId = null
            this.storeArea = []
            this.storeList.forEach(item=>{
                if(item.id == this.addForm.storeId){
                    this.storeArea = item.next
                }
            })
        },
        testContent(h, { node, data, store }){
            let html = null
            let eidt = <img  src='../../static/img/edit.png' style='margin-right: 8px;' on-click={ () => this.edit(data) }/>
            let close = <img  src='../../static/img/close.png' style='margin-right: 4px;' on-click={ () => this.delete(data) }/>
            let lock = <img  src='../../static/img/lock.png' style='margin-right: 4px;' />
            // let lock1 = <img  src='../../static/img/lock1.png' style='margin-right: 4px;' />
            if(data.layer==undefined){
                data.layer = 0
            }
            let widthData = ['160px','116px','100px','80px']
            let styleJson = {
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                fontSize: '14px',
                paddingRight: '8px',
            }
            // "flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;"
            if(data.isLocked){
                if(data.layer==-1){
                    if(data.lastCount){
                        lock = <img  src='../../static/img/lock1.png' style='margin-right: 4px;' />
                    }
                    html = <span title={data.warehouseName}  style={styleJson}>
                                <span>
                                    <span className='show-ellipsis' style={{width:`${widthData[data.layer+1]}`,display:'inline-block'}}>{data.warehouseName}</span>
                                </span>
                                <span>
                                    {lock}
                                    {eidt}
                                </span>
                            </span>
                }else{
                    if(data.lastCount){
                        lock = <img  src='../../static/img/lock1.png' style='margin-right: 4px;' />
                    }
                    html = <span  title={data.warehouseName} style={styleJson}>
                            <span>
                                <span class='show-ellipsis' style={{width:`${widthData[data.layer+1]}`,display:'inline-block'}}>{data.warehouseName}</span>
                            </span>
                            <span>
                                {lock}
                                {eidt}
                                {close}
                            </span>
                        </span>
                }

            }else{
               if(data.layer==-1){
                    html = <span   title={data.warehouseName} style={styleJson}>
                                <span>
                                    <span class='show-ellipsis' style={{width:`${widthData[data.layer+1]}`,display:'inline-block'}}>{data.warehouseName}</span>
                                </span>
                                <span>
                                    {eidt}
                                </span>
                            </span>
                }else{
                    html = <span title={data.warehouseName} style={styleJson}>
                                <span>
                                    <span class='show-ellipsis' style={{width:`${widthData[data.layer+1]}`,display:'inline-block'}}>{data.warehouseName}</span>
                                </span>
                                <span>
                                    {eidt}
                                    {close}
                                </span>
                            </span>
                }
            }
            return (html);
        },
        edit(data){
            this.nodeClick++
            this.editStoreDialogVisible = true
            this.editData = data
            this.addForm.warehouseName = data.warehouseName
            if(data.layer==1){
                this.showTitle = '编辑库区'
                this.addForm.type = 2
            }else if(data.layer==2){
                this.showTitle = '编辑库位'
                this.addForm.type = 3
            }else if(data.layer==-1){
                this.addForm.type = -1
            }else{
                this.addForm.warehouseAddress = data.warehouseAddress
                this.addForm.position = data.position
                this.addForm.type = 1
                this.editData.layer==0
                this.showTitle = '编辑仓库'
            }
        },
        submitEditStore(){
             this.$refs['edit'].validate((valid) => {
                if(valid){
                    let data = this.editData
                    let params = {
                            layer:data.layer,
                            parentId:data.parentId,
                            id:data.id,
                    }
                    if(data.layer==0){
                        params.warehouseAddress = this.addForm.warehouseAddress
                        params.position = this.addForm.position
                        params.warehouseName=this.addForm.warehouseName
                    }else if(data.layer==1){
                        params.warehouseName=this.addForm.storeAreaName
                    }else if(data.layer==2){
                        params.warehouseName=this.addForm.storeLocation
                    }else if(data.layer==-1){
                        params.warehouseName=this.addForm.companyName
                    }
                    this.$RequestUtil.post({
                        url: '/api/warehouseController/updateWarehouse',
                        type:'sync',
                        params,
                        success: (res) => {
                            if(res.code ==0){
                                this.$message.success('修改成功')
                                this.cancelEditDialog()
                                this.loadStoreList(data.id)
                            }else{
                                this.$message.error(res.msg);
                            }
                        }
                    })
                }
             })
        },
        cancelEditDialog(){
            this.editStoreDialogVisible = false
            this.addForm={
                type:null,
                storeId:null,
                storeAreaId:null,
                position:null,
                warehouseAddress:null,
                warehouseName:null,
                storeLocation:null,
                storeAreaName:null
            }
            this.editData={}
        },
        delete(data){
            this.nodeClick++
            let title =''
            if(data.layer==1){
                title ='库区'
            }else if(data.layer==2){
                title ='库位'
            }else{
                title ='仓库'
            }
            this.$confirm(`确认删除该${title}?`, '提示', {
                cancelButtonClass: "btn-custom-cancel",
				confirmButtonText: '确定',
            	cancelButtonText: '取消',
            	type: 'warning'
			}).then(() => {
                this.$RequestUtil.post({
                    url: '/api/warehouseController/removeWarehouse',
                    type:'sync',
                    params:{
                        id:data.id
                    },
                    success:(res)=>{
                        if(res.code==0){
                            this.$message.success('删除成功')
                            this.loadStoreList()
                        }else{
                            this.$message.error(res.msg)
                        }
                    }
                })
            })
        },
        async loadStoreList(selecTree){
            let res = await this.$RequestUtil.getAsync({
                 url: '/api/warehouseController/listWarehouse',
                type:'sync',
				params: {
                },
            })

            if(res.code==0){
                let arr = []
                arr.push(res.data)
                this.data = arr
                this.storeList = this.data[0].next
                if(selecTree){
                    this.selecTree = selecTree
                }else{
                    this.selecTree  = res.data.id
                }
                this.$nextTick(() => {
                    this.$refs.tree.setCurrentKey(this.selecTree)
                })
            }else{
                this.$message.error(res.message||res.msg)
            }

        },
        async showCheckDetail(){
            let arr = []
            let data = this.selectTreeData
            let str=this.selectTreeData.warehouseName
            if(data.layer==0||data.layer==undefined){ //选择仓库
                arr.push({id:data.id,name:str})
                if(data.next){
                    data.next.forEach(item=>{
                        arr.push({id:item.id,name:str+'/'+item.warehouseName})
                        if(item.next){
                            item.next.forEach(d=>{
                                arr.push({id:d.id,name:str+'/'+item.warehouseName+'/'+d.warehouseName})
                            })
                        }
                    })
                }
            }
            if(data.layer==1){
                arr.push({id:data.id,name:str})
                if(data.next){
                    data.next.forEach(d=>{
                        arr.push({id:d.id,name:str+'/'+d.warehouseName})
                    })
                }
            }
            if(data.layer==2){
                arr.push({id:data.id,name:str})
            }
            this.treeOption1 = arr
            let res = await this.loadRecordOfMaterial()
            if(res.code==0){
                this.checkDialog = true
            }
        },
        async showCheckStore(){
            log('选择节点',this.clickNode)
            if(!this.addMaterialForm.warehouseId){
                this.$message.warning('请先选择左侧列表需要盘点的仓库、库区或库位')
                return
            }
            if(this.clickNode&&this.clickNode.lastCount){
                this.showCheckDetail()
            }else{
                this.$confirm('此操作将锁定仓库, 仓库锁定后不可进行出入库操作，是否继续?', '提示', {
                    cancelButtonClass: "btn-custom-cancel",
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then( ()=>{
                    this.showCheckDetail()
                })
            }

        },
        cancelAddDialog(){
            this.addStoreDialogVisible = false
            this.addForm={
                        type:null,
                        storeId:null,
                        storeAreaId:null,
                        position:null,
                        warehouseAddress:null,
                        warehouseName:null,
                        storeLocation:null,
                        storeAreaName:null
                    }
        },
        addStore(){
            if(!this.addMaterialForm.warehouseId){
                this.$message.warning('请先选择左侧列表仓库、库区或库位')
                return
            }
            if(this.selectTreeData.isLocked){
                this.$message.warning('当前仓库已锁定，不可进行出入库操作')
                return
            }
            this.addDialogVisible = true
        },
        handleNodeClick(ev){
            //当点击编辑和删除的时候nodeClick++阻止节点click事件执行
            if(this.nodeClick>1){
                this.nodeClick =1
                return
            }
            if(ev.layer==-1){
                this.addMaterialForm.warehouseId = null
            }
            if(ev.layer!=-1){
                this.addMaterialForm.warehouseId = ev.id
                this.selectTreeData = ev
            }
            if(ev.layer==undefined||ev.layer==0){
                this.topWarehouseId = ev.id
            }
            if(ev.layer==1){
                this.topWarehouseId = ev.parentId
            }
            if(this.searchForm.warehouseId&&this.searchForm.warehouseId==ev.id){
                return
            }
            if(!this.searchForm.warehouseId&&ev.layer==-1){
                return
            }
            this.searchForm.warehouseId = ev.id
            this.clickNode = ev
            this.btnPressType = 1
            this.tableCurrentPage = 1
            this.search()
        },
        addWindowShow(){
            this.addStoreDialogVisible = true
        },
        btnSearch:function(){
            this.tableCurrentPage = 1;
            this.btnPressType = 1
            this.search();
        },
        clearSearch(){
            let form = this.searchForm;
            this.btnPressType = 2;
            form.materialId=null
            form.productionBatch= ''
            this.batchOption = []
        },
        search:function(){
            let temp;
            switch (this.btnPressType) {
              case 1:
                temp = commonUtils.cloneObj(this.searchForm);
                this.searchFormTemp = commonUtils.cloneObj(temp);
                break;
              case 0:
                temp ={
                    materialId:null,
                    warehouseId:null,
                    productionBatch:null
                };
                break;
              case 2:
                temp = this.searchFormTemp;
                break;
              case 3:
                temp = this.searchFormTemp;
                break;
            }
            this.$RequestUtil.get({
                url: '/api/stock/listStock',
                type:'sync',
				    params: {
                    pageNum:this.tableCurrentPage,
                    pageSize:10,
                    materialId:temp.materialId,
                    warehouseId:temp.warehouseId,
                    productionBatch:temp.productionBatch
                },
                success: (res) => {
                    if(res.msg == this.$Global.RESPONSE.SUCCESS){
                        this.tableData = res.data;
                        this.tableTotalPage = res.totalPages;
                        if(res.totalPages == 0&&this.fristLoad){
                            this.$message.warning('查询不到符合条件的数据');
                        }
                        this.fristLoad =  true
                    }else{
                        this.$message.error(res.message||res.msg)
                    }
                }
            });
        },
        pageChange:function(targetPage){
            this.tableCurrentPage = targetPage;
            this.btnPressType = 3;
            this.search();
        },
        initTable:function(){
            this.search();
        },
    }
}
</script>
<style scoped>
.show-ellipsis {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
#storeManagement{
    background: #f6f7fa;
    display: flex;
    margin-left: -8px;
    margin-top: -20px;
}
@media screen and (min-width:1900px){
	#storeManagement{
		height: 791px;
        width:102.7%
	}
}
@media screen and (min-width:1400px) and (max-width: 1800px){
	#storeManagement{
		height: 778px;
		width:103.7%;
	}
}
@media screen and (min-width:1200px) and (max-width: 1399px){
	#storeManagement{
		height: 750px;
		width:105%;
        padding-bottom: 16px;
	}
}
.left-store-nav{
    width: 240px;
    margin-right: 16px;
    background: #fff;

}

.left-store-nav .tree-list{
    width: 220px;
    margin: 0 10px;
}
.right-store-list{
    width: 100%;
    background: #fff;
    height: 100%;
}

#storeManagement .title{
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
    display:inline-block;
    width: 70px;
    text-align: right
}
#storeManagement .value{
    width: 188px;
}
.el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
}

.table_searchbar{
    width:100%;
    margin-top: 20px;
    margin-bottom: 20px;
}
.import_upload{
	display: inline;
}
.page{
    display: flex;
    justify-content: flex-end;
}
@media screen and (max-width: 1450px){
    .page{
        display: flex;
        justify-content: flex-end;
        margin-bottom:30px;
    }
}
.total_page{
    margin-top: 20px;
    margin-right: 26px;
    color:#606266;
    font-size: 14px;
}
.delete{
    width: 18px;
    height: 19px;
    background-image:url('../../../static/img/del.png');
    cursor: pointer;
    background-repeat: no-repeat;
}
.delete:hover{
    background-image: url('../../../static/img/del-hover.png');
    background-repeat: no-repeat;
}

@media screen and (max-width: 1366px){
  .y_inputWidth .el-input{
    width: 100% !important;
  }
}
.qrcode_div{
    text-align:center;
}
</style>
<style>
.show-ellipsis {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.table_searchbar .el-button--mini, .el-button--mini.is-round {
    padding: 7px 10px;
}
.timer .el-time-panel {
    width: 140px;
    left: 6px;
}
@media screen and (min-width:1900px){
    .left-store-nav .el-scrollbar__wrap{
        overflow-x: hidden;
        height:700px;
        overflow-x: hidden;
        margin-bottom: 0px !important;
    }
}
@media screen and (min-width:1400px) and (max-width: 1800px){
	.left-store-nav .el-scrollbar__wrap{
        overflow-x: hidden;
        height:700px;
        overflow-x: hidden;
         margin-bottom: 0px !important;
    }
}
@media screen and (min-width:1200px) and (max-width: 1399px){
	.left-store-nav .el-scrollbar__wrap{
        overflow-x: hidden;
        height:680px;
        overflow-x: hidden;
        margin-bottom: 0px !important;
    }
}
.check-list::before{
    background-color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/views/stock/StoreManagement.vue